module.exports = __webpack_public_path__ + "static/media/Icon feather-message-square.4319fda1.svg";